// SPDX-License-Identifier: AGPL-3.0-or-later

export const SVGMasks = () => (
	<svg
		viewBox="0 0 1 1"
		aria-hidden={true}
		style={{
			position: 'absolute',
			pointerEvents: 'none',
			top: '-1px',
			left: '-1px',
			width: 1,
			height: 1,
		}}
	>
		<defs>
			<mask id="flx-mask-avatar-plain-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.8125" cy="0.8125" r="0.3125" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.5" y="0.3125" width="0.625" height="1" rx="0.0625" ry="0.0625" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.28125" cy="0.8125" r="0.3125" />
				<rect fill="black" x="0.34375" y="0.5" width="0.9375" height="0.625" />
				<circle fill="black" cx="0.34375" cy="0.8125" r="0.3125" />
			</mask>
			<mask id="flx-mask-presence-online-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.8125" cy="0.8125" r="0.3125" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1850" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.8125" cy="0.8125" r="0.3125" />
				<circle fill="black" cx="0.6875" cy="0.6875" r="0.25" />
			</mask>
			<mask id="flx-mask-presence-dnd-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.8125" cy="0.8125" r="0.3125" />
				<rect fill="black" x="0.59375" y="0.75" width="0.4375" height="0.125" rx="0.0625" ry="0.0625" />
			</mask>
			<mask id="flx-mask-presence-offline-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.8125" cy="0.8125" r="0.3125" />
				<circle fill="black" cx="0.8125" cy="0.8125" r="0.1875" />
			</mask>
			<mask id="flx-mask-presence-typing-16" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.03125" y="0.5" width="1.5625" height="0.625" rx="0.3125" ry="0.3125" />
			</mask>

			<mask id="flx-mask-avatar-plain-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.3" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.55" y="0.4" width="0.6" height="0.9" rx="0.1" ry="0.1" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.225" cy="0.85" r="0.3" />
				<rect fill="black" x="0.475" y="0.55" width="0.75" height="0.6" />
				<circle fill="black" cx="0.475" cy="0.85" r="0.3" />
			</mask>
			<mask id="flx-mask-presence-online-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.3" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1850" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.3" />
				<circle fill="black" cx="0.75" cy="0.75" r="0.2" />
			</mask>
			<mask id="flx-mask-presence-dnd-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.3" />
				<rect fill="black" x="0.65" y="0.8" width="0.4" height="0.1" rx="0.05" ry="0.05" />
			</mask>
			<mask id="flx-mask-presence-offline-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.3" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.15" />
			</mask>
			<mask id="flx-mask-presence-typing-20" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.225" y="0.6" width="1.25" height="0.5" rx="0.3" ry="0.3" />
			</mask>

			<mask id="flx-mask-avatar-plain-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.291667" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.541667" y="0.416667" width="0.583333" height="0.833333" rx="0.125" ry="0.125" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.145833" cy="0.833333" r="0.291667" />
				<rect fill="black" x="0.520833" y="0.541667" width="0.625" height="0.583333" />
				<circle fill="black" cx="0.520833" cy="0.833333" r="0.291667" />
			</mask>
			<mask id="flx-mask-presence-online-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.291667" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1850" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.291667" />
				<circle fill="black" cx="0.75" cy="0.75" r="0.208333" />
			</mask>
			<mask id="flx-mask-presence-dnd-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.291667" />
				<rect fill="black" x="0.645833" y="0.770833" width="0.375" height="0.125" rx="0.0625" ry="0.0625" />
			</mask>
			<mask id="flx-mask-presence-offline-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.291667" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.125" />
			</mask>
			<mask id="flx-mask-presence-typing-24" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.3125" y="0.625" width="1.041667" height="0.416667" rx="0.291667" ry="0.291667" />
			</mask>

			<mask id="flx-mask-avatar-plain-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.84375" cy="0.84375" r="0.25" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.59375" y="0.5" width="0.5" height="0.6875" rx="0.125" ry="0.125" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.078125" cy="0.84375" r="0.25" />
				<rect fill="black" x="0.609375" y="0.59375" width="0.46875" height="0.5" />
				<circle fill="black" cx="0.609375" cy="0.84375" r="0.25" />
			</mask>
			<mask id="flx-mask-presence-online-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.84375" cy="0.84375" r="0.25" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1850" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.84375" cy="0.84375" r="0.25" />
				<circle fill="black" cx="0.75" cy="0.75" r="0.1875" />
			</mask>
			<mask id="flx-mask-presence-dnd-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.84375" cy="0.84375" r="0.25" />
				<rect fill="black" x="0.6875" y="0.796875" width="0.3125" height="0.09375" rx="0.046875" ry="0.046875" />
			</mask>
			<mask id="flx-mask-presence-offline-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.84375" cy="0.84375" r="0.25" />
				<circle fill="black" cx="0.84375" cy="0.84375" r="0.09375" />
			</mask>
			<mask id="flx-mask-presence-typing-32" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.453125" y="0.6875" width="0.78125" height="0.3125" rx="0.25" ry="0.25" />
			</mask>

			<mask id="flx-mask-avatar-plain-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.222222" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.611111" y="0.527778" width="0.444444" height="0.611111" rx="0.111111" ry="0.111111" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.041667" cy="0.833333" r="0.222222" />
				<rect fill="black" x="0.625" y="0.611111" width="0.416667" height="0.444444" />
				<circle fill="black" cx="0.625" cy="0.833333" r="0.222222" />
			</mask>
			<mask id="flx-mask-presence-online-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.222222" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1850" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.222222" />
				<circle fill="black" cx="0.75" cy="0.75" r="0.166667" />
			</mask>
			<mask id="flx-mask-presence-dnd-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.222222" />
				<rect fill="black" x="0.694444" y="0.791667" width="0.277778" height="0.083333" rx="0.041667" ry="0.041667" />
			</mask>
			<mask id="flx-mask-presence-offline-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.222222" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.083333" />
			</mask>
			<mask id="flx-mask-presence-typing-36" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.486111" y="0.694444" width="0.694444" height="0.277778" rx="0.222222" ry="0.222222" />
			</mask>

			<mask id="flx-mask-avatar-plain-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.225" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.625" y="0.55" width="0.45" height="0.6" rx="0.1" ry="0.1" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.075" cy="0.85" r="0.225" />
				<rect fill="black" x="0.625" y="0.625" width="0.45" height="0.45" />
				<circle fill="black" cx="0.625" cy="0.85" r="0.225" />
			</mask>
			<mask id="flx-mask-presence-online-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.225" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1711" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.225" />
				<circle fill="black" cx="0.775" cy="0.775" r="0.15" />
			</mask>
			<mask id="flx-mask-presence-dnd-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.225" />
				<rect fill="black" x="0.7" y="0.8" width="0.3" height="0.1" rx="0.05" ry="0.05" />
			</mask>
			<mask id="flx-mask-presence-offline-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.225" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.1" />
			</mask>
			<mask id="flx-mask-presence-typing-40" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.475" y="0.7" width="0.75" height="0.3" rx="0.225" ry="0.225" />
			</mask>

			<mask id="flx-mask-avatar-plain-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.863636" cy="0.863636" r="0.227273" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.636364" y="0.568182" width="0.454545" height="0.590909" rx="0.113636" ry="0.113636" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.102273" cy="0.863636" r="0.227273" />
				<rect fill="black" x="0.625" y="0.636364" width="0.477273" height="0.454545" />
				<circle fill="black" cx="0.625" cy="0.863636" r="0.227273" />
			</mask>
			<mask id="flx-mask-presence-online-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.863636" cy="0.863636" r="0.227273" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1600" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.863636" cy="0.863636" r="0.227273" />
				<circle fill="black" cx="0.772727" cy="0.772727" r="0.159091" />
			</mask>
			<mask id="flx-mask-presence-dnd-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.863636" cy="0.863636" r="0.227273" />
				<rect fill="black" x="0.715909" y="0.818182" width="0.295455" height="0.090909" rx="0.045455" ry="0.045455" />
			</mask>
			<mask id="flx-mask-presence-offline-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.863636" cy="0.863636" r="0.227273" />
				<circle fill="black" cx="0.863636" cy="0.863636" r="0.090909" />
			</mask>
			<mask id="flx-mask-presence-typing-44" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.465909" y="0.704545" width="0.795455" height="0.318182" rx="0.227273" ry="0.227273" />
			</mask>

			<mask id="flx-mask-avatar-plain-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.875" cy="0.875" r="0.208333" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.666667" y="0.604167" width="0.416667" height="0.541667" rx="0.104167" ry="0.104167" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.09375" cy="0.875" r="0.208333" />
				<rect fill="black" x="0.65625" y="0.666667" width="0.4375" height="0.416667" />
				<circle fill="black" cx="0.65625" cy="0.875" r="0.208333" />
			</mask>
			<mask id="flx-mask-presence-online-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.208333" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1600" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.208333" />
				<circle fill="black" cx="0.791667" cy="0.791667" r="0.145833" />
			</mask>
			<mask id="flx-mask-presence-dnd-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.208333" />
				<rect fill="black" x="0.739583" y="0.833333" width="0.270833" height="0.083333" rx="0.041667" ry="0.041667" />
			</mask>
			<mask id="flx-mask-presence-offline-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.208333" />
				<circle fill="black" cx="0.875" cy="0.875" r="0.083333" />
			</mask>
			<mask id="flx-mask-presence-typing-48" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.510417" y="0.729167" width="0.729167" height="0.291667" rx="0.208333" ry="0.208333" />
			</mask>

			<mask id="flx-mask-avatar-plain-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.875" cy="0.875" r="0.196429" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.678571" y="0.607143" width="0.392857" height="0.535714" rx="0.089286" ry="0.089286" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1.089286" cy="0.875" r="0.196429" />
				<rect fill="black" x="0.660714" y="0.678571" width="0.428571" height="0.392857" />
				<circle fill="black" cx="0.660714" cy="0.875" r="0.196429" />
			</mask>
			<mask id="flx-mask-presence-online-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.196429" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1433" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.196429" />
				<circle fill="black" cx="0.803571" cy="0.803571" r="0.142857" />
			</mask>
			<mask id="flx-mask-presence-dnd-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.196429" />
				<rect fill="black" x="0.75" y="0.839286" width="0.25" height="0.071429" rx="0.035714" ry="0.035714" />
			</mask>
			<mask id="flx-mask-presence-offline-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.875" cy="0.875" r="0.196429" />
				<circle fill="black" cx="0.875" cy="0.875" r="0.089286" />
			</mask>
			<mask id="flx-mask-presence-typing-56" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.517857" y="0.732143" width="0.714286" height="0.285714" rx="0.196429" ry="0.196429" />
			</mask>

			<mask id="flx-mask-avatar-plain-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.14" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.71" y="0.66" width="0.28" height="0.38" rx="0.065" ry="0.065" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="1" cy="0.85" r="0.14" />
				<rect fill="black" x="0.7" y="0.71" width="0.3" height="0.28" />
				<circle fill="black" cx="0.7" cy="0.85" r="0.14" />
			</mask>
			<mask id="flx-mask-presence-online-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.14" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1433" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.14" />
				<circle fill="black" cx="0.8" cy="0.8" r="0.1" />
			</mask>
			<mask id="flx-mask-presence-dnd-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.14" />
				<rect fill="black" x="0.75625" y="0.825" width="0.1875" height="0.05" rx="0.025" ry="0.025" />
			</mask>
			<mask id="flx-mask-presence-offline-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.85" cy="0.85" r="0.14" />
				<circle fill="black" cx="0.85" cy="0.85" r="0.0625" />
			</mask>
			<mask id="flx-mask-presence-typing-80" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.6" y="0.75" width="0.5" height="0.2" rx="0.14" ry="0.14" />
			</mask>

			<mask id="flx-mask-avatar-plain-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-avatar-notch-circle-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.14" />
			</mask>
			<mask id="flx-mask-avatar-notch-phone-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.693333" y="0.651667" width="0.28" height="0.363333" rx="0.065" ry="0.065" />
			</mask>
			<mask id="flx-mask-avatar-notch-typing-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.983333" cy="0.833333" r="0.14" />
				<rect fill="black" x="0.683333" y="0.693333" width="0.3" height="0.28" />
				<circle fill="black" cx="0.683333" cy="0.833333" r="0.14" />
			</mask>
			<mask id="flx-mask-presence-online-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.14" />
			</mask>
			<mask id="flx-mask-presence-online-mobile-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.0900" />
				<rect fill="black" x="0.1400" y="0.1188" width="0.7200" height="0.5250" rx="0.0720" ry="0.0540" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.0975" />
			</mask>
			<mask id="flx-mask-presence-idle-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.14" />
				<circle fill="black" cx="0.783333" cy="0.783333" r="0.1" />
			</mask>
			<mask id="flx-mask-presence-dnd-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.14" />
				<rect fill="black" x="0.741667" y="0.804167" width="0.183333" height="0.058333" rx="0.029167" ry="0.029167" />
			</mask>
			<mask id="flx-mask-presence-offline-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.833333" cy="0.833333" r="0.14" />
				<circle fill="black" cx="0.833333" cy="0.833333" r="0.058333" />
			</mask>
			<mask id="flx-mask-presence-typing-120" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0.583333" y="0.733333" width="0.5" height="0.2" rx="0.14" ry="0.14" />
			</mask>

			<mask id="flx-mask-presence-online" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
			<mask id="flx-mask-presence-idle" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.25" cy="0.25" r="0.375" />
			</mask>
			<mask id="flx-mask-presence-dnd" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<rect fill="black" x="0.125" y="0.375" width="0.75" height="0.25" rx="0.125" ry="0.125" />
			</mask>
			<mask id="flx-mask-presence-offline" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
				<circle fill="black" cx="0.5" cy="0.5" r="0.25" />
			</mask>
			<mask id="flx-mask-presence-typing" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.5" ry="0.5" />
			</mask>
			<mask id="flx-mask-presence-online-mobile" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<rect fill="white" x="0" y="0" width="1" height="1" rx="0.12" ry="0.09" />
				<rect fill="black" x="0.1400" y="0.06" width="0.72" height="0.5250" rx="0.04" ry="0.03" />
				<ellipse fill="black" cx="0.5" cy="0.83" rx="0.13" ry="0.098" />
			</mask>
			<mask id="flx-mask-avatar-plain" maskContentUnits="objectBoundingBox" viewBox="0 0 1 1">
				<circle fill="white" cx="0.5" cy="0.5" r="0.5" />
			</mask>
		</defs>
	</svg>
);
